import { BehaviorSubject, Observable } from 'rxjs';
import { publish, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class MessageAlertService {
  private messageAlert: BehaviorSubject<IMessageAlert> = new BehaviorSubject<IMessageAlert>({} as any);
  readonly messageAlert$: Observable<IMessageAlert> = this.messageAlert.asObservable().pipe(publish(), refCount());

  constructor() {}

  ngOnInit(): void {}

  public notifyMessage(messageAlert: IMessageAlert): void {
    setTimeout(() => {
      this.messageAlert.next(messageAlert);
    }, 5);
  }

  public clearMessage(): void {
    const messageAlert: IMessageAlert = {} as IMessageAlert;
    messageAlert.Message = undefined;
    messageAlert.Type = undefined;
    messageAlert.Action = undefined;
    setTimeout(() => {
      this.messageAlert.next(messageAlert);
    }, 5);
  }
}

export interface IMessageAlert {
  Type: string;
  Message: string;
  Action?: Action;
  CTAMessage?: string;
}
